import axios from 'axios'
import router from '../router'

const request = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL}`,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    console.error('Request error:', error)
    return Promise.reject(error)
  },
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    const { response } = error

    // 只处理 token 失效的情况
    if (response?.status === 401 && !response.config.url.includes('/auth/login')) {
      localStorage.removeItem('token')
      router.push('/login')
    }

    // 其他错误直接返回给调用方处理
    return Promise.reject(error)
  },
)

export default request
